// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1ngQV","inputWrap":"CustomTip_inputWrap__ddU8l"};